import type { SxProps, Theme } from "@mui/material";

const workspaceStyle: SxProps = {
  pb: 4,
};

const projectStyle: SxProps = (theme: Theme) => ({
  background: theme.palette.box1.main,
  borderRadius: 2,
  boxShadow: 1,
  p: 2,
  color: theme.palette.box1.contrastText,
  mb: 2,

  "&:hover": {
    background: theme.palette.box1.hover,
    textDecoration: "none",
  },
});

const projectBarStyle: SxProps = {
  display: "flex",
  width: "100%",
  alignItems: "center",
};

const projectBarNameStyle: SxProps = {
  flex: 1,
  pr: 4,
};

const projectBarProgressStyle: SxProps = {
  minWidth: 180,
  pr: 4,
};

const projectBarCountStyle: SxProps = {
  width: 130,
  fontSize: "0.75rem",
};

export {
  workspaceStyle,
  projectStyle,
  projectBarStyle,
  projectBarNameStyle,
  projectBarProgressStyle,
  projectBarCountStyle,
};
